import { App } from "antd";
import { ReactNode, useCallback, useState } from "react";
import { Action } from "redux";
import { ThunkAction } from "redux-thunk";
import { RootState, useAppDispatch } from "../../store";
import { useGetDeleteDialogProps } from "./getDeleteDialogProps";

export const useDefaultDeleteModal = (
  deleteFunc: (id: string | any) => ThunkAction<void, RootState, unknown, Action>,
  reloadData: () => void,
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>,
  onSuccess?: () => void
) => {
  const { modal } = App.useApp();

  const dispatch = useAppDispatch();

  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  const [options] = useGetDeleteDialogProps(isDeleting);

  const openDeleteModal = useCallback(
    (id: string | any, title: string, subTitle?: ReactNode): void => {
      modal.confirm({
        ...options,
        title,
        content: (
          <div className="text-md mb-1">
            Are you sure you want to delete?
            {subTitle}
          </div>
        ),
        onOk: async () => {
          setIsDeleting(true);

          try {
            await Promise.resolve(dispatch(deleteFunc(id)));
            setIsDeleting(false);
            reloadData();
            if (setIsOpen) {
              setIsOpen(false);
            }
            if (onSuccess) {
              onSuccess();
            }
          } catch {
            return setIsDeleting(false);
          }
        }
      });
    },
    [modal, options, dispatch, deleteFunc, reloadData, setIsOpen, onSuccess]
  );

  return { openDeleteModal };
};
